import { ReactUtils } from '@festina-life/core'
import { CopyToClipboard } from '@festina-life/ui/actions'
import { Tooltip } from '@festina-life/ui/feedback'
import { Icon } from '@festina-life/ui/structure'
import cx from 'classnames'
import {
  type ComponentProps,
  type PropsWithChildren,
  type ReactNode,
  useEffect,
  useRef,
  useState,
} from 'react'

export const OverviewItem = ({
  children,
  iconName,
  title,
  childrenClassName,
  hasCopyButton = false,
}: PropsWithChildren<{
  iconName: ComponentProps<typeof Icon>['name']
  title?: ReactNode
  hasCopyButton?: boolean
  childrenClassName?: string
}>) => {
  const childrenRef = useRef<HTMLSpanElement>(null)
  const [textValue, setTextValue] = useState('')

  useEffect(() => {
    if (childrenRef.current?.innerText) {
      setTextValue(childrenRef.current.innerText)
    }
  }, [])

  return (
    <ReactUtils.ConditionalWrap
      condition={!!title || hasCopyButton}
      wrap={(children) => (
        <Tooltip
          tipClassName={cx(
            hasCopyButton &&
              cx(title ? 'ps-0! py-0! flex items-center' : 'p-1!'),
          )}
          tip={
            <>
              {hasCopyButton && (
                <CopyToClipboard
                  copyValue={textValue}
                  onCopied={(target) => {
                    target.parentElement?.click() // close the tooltip when we are done copying
                  }}
                />
              )}
              {title}
            </>
          }
          placement="right"
          isInteractive={hasCopyButton}
        >
          {children}
        </Tooltip>
      )}
    >
      <span className={cx('flex items-center gap-1')}>
        <Icon name={iconName} />
        <span ref={childrenRef} className={childrenClassName}>
          {children}
        </span>
      </span>
    </ReactUtils.ConditionalWrap>
  )
}
